import './EarliestDelivery.scss';
import Component from './EarliestDelivery.js';
export default Component;
